import "vant/lib/toast/style";
import _Toast from "vant/lib/toast";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import Nav from "@/components/nav/navBar.vue";
import { sendMapEvent } from "@/utils/analytics";
import loadingAnimaton from "@/components/loadingAnimaton/loadingAnimaton.vue";
import MyReportButton from "@/components/myReportButton/myReportButton.vue";
import { i18n } from "@/i18n/i18n-setup";
import Reval from "@/views/vipPage/reval/reval.vue"; // import stars from "@/views/vipPage/stars/stars.vue";

import vipGetReportBtn from "@/components/vipGetReportBtn/vipGetReportBtn.vue";

var VipFullToast =
/*#__PURE__*/
function (_Vue) {
  _inherits(VipFullToast, _Vue);

  function VipFullToast() {
    var _this;

    _classCallCheck(this, VipFullToast);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VipFullToast).apply(this, arguments));
    _this.key = "";
    _this.listData = [{
      img: _this.$remoteImg("icons/toast/free_label.png"),
      text: i18n.t("vip_mask.full_mask_page")[0]
    }, {
      img: _this.$remoteImg("icons/toast/no_charge.png"),
      text: i18n.t("vip_mask.full_mask_page")[1]
    }, {
      img: _this.$remoteImg("icons/toast/face_secret.png"),
      text: i18n.t("vip_mask.full_mask_page")[2]
    }, {
      img: _this.$remoteImg("icons/toast/fate_palm.png"),
      text: i18n.t("vip_mask.full_mask_page")[3]
    }, {
      img: _this.$remoteImg("icons/toast/horoscope_forecast.png"),
      text: i18n.t("vip_mask.full_mask_page")[4]
    }, {
      img: _this.$remoteImg("icons/toast/unlock_all_features.png"),
      text: i18n.t("vip_mask.full_mask_page")[5]
    }];
    return _this;
  }

  _createClass(VipFullToast, [{
    key: "goBack",
    value: function goBack() {
      this.routerReplace({
        name: "home"
      });
    }
  }, {
    key: "created",
    value: function created() {
      sendMapEvent("uia_vip_before_unload_full", {
        key: 'show'
      });
    }
  }, {
    key: "buyVIP",
    value: function () {
      var _buyVIP = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                sendMapEvent("uia_vip_before_unload_full", {
                  key: 'click'
                });
                _context.next = 4;
                return this.payVip();

              case 4:
                result = _context.sent;

                if (result) {
                  this.updateResultByName({
                    name: "canShowSuccessToast",
                    result: true
                  });
                  this.goBack();
                  sendMapEvent("uia_vip_buyway", {
                    key: 'before_unload_full'
                  });
                  sendMapEvent("uia_vip_before_unload_full", {
                    key: 'buy'
                  });
                } else {
                  _Toast("".concat(i18n.t("common.toast.payment_failed")));
                }

                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function buyVIP() {
        return _buyVIP.apply(this, arguments);
      }

      return buyVIP;
    }()
  }, {
    key: "getText",
    get: function get() {
      console.log('i18n.t("common.button.try_for_free")', i18n.t("common.button.try_for_free"));
      return i18n.t("common.button.try_for_free");
    }
  }]);

  return VipFullToast;
}(Vue);

tslib_1.__decorate([Action(types.ROUTER_GO_BACK)], VipFullToast.prototype, "routerGoBack", void 0);

tslib_1.__decorate([Action(types.PAY_VIP)], VipFullToast.prototype, "payVip", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_MORNING_NOOTICE_STATUS)], VipFullToast.prototype, "updateMoringNotice", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_EVNING_NOOTICE_STATUS)], VipFullToast.prototype, "updateEveningNotice", void 0);

tslib_1.__decorate([Getter(types.GETTER_MORNING_NOOTICE_STATUS)], VipFullToast.prototype, "morgingNoticeStatus", void 0);

tslib_1.__decorate([Getter(types.GETTER_EVNING_NOOTICE_STATUS)], VipFullToast.prototype, "evengingNotificationStatus", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_SERVICE_LIST)], VipFullToast.prototype, "updateServiceList", void 0);

tslib_1.__decorate([Getter(types.GETTER_SERVICE_LIST)], VipFullToast.prototype, "serviceList", void 0);

tslib_1.__decorate([Action(types.ROUTER_PUSH)], VipFullToast.prototype, "routerPush", void 0);

tslib_1.__decorate([Action(types.ROUTER_REPLACE)], VipFullToast.prototype, "routerReplace", void 0);

tslib_1.__decorate([Action(types.RATE_US)], VipFullToast.prototype, "rateUs", void 0);

tslib_1.__decorate([Mutation(types.UPDATE_RESULT_BY_NAME)], VipFullToast.prototype, "updateResultByName", void 0);

VipFullToast = tslib_1.__decorate([Component({
  components: {
    Nav: Nav,
    loadingAnimaton: loadingAnimaton,
    MyReportButton: MyReportButton,
    // stars,
    Reval: Reval,
    vipGetReportBtn: vipGetReportBtn
  }
})], VipFullToast);
export default VipFullToast;